import React from 'react';
import merge from 'lodash/merge';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'emotion-theming';
import defaultTheme from './themes/default';

// merge the color mode with the base theme
// to create a new theme object
var getThemeColors = function getThemeColors(theme, mode) {
  return merge({}, theme, {
    colors: get(theme.colors.modes, mode, theme.colors)
  });
};

var getMergedTheme = function getMergedTheme(themeOverrides) {
  return merge({}, defaultTheme, themeOverrides);
};

var AdaptThemeProvider = function AdaptThemeProvider(_ref) {
  var mode = _ref.mode,
      _ref$themeOverrides = _ref.themeOverrides,
      themeOverrides = _ref$themeOverrides === void 0 ? {} : _ref$themeOverrides,
      children = _ref.children;
  var mergedTheme = getMergedTheme(themeOverrides);
  var themeWithColorMode = getThemeColors(mergedTheme, mode);
  return React.createElement(ThemeProvider, {
    theme: themeWithColorMode
  }, children);
};

AdaptThemeProvider.defaultProps = {
  mode: 'light'
};
export default AdaptThemeProvider;